exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 896px) {\n.c-btn-wrap[data-v-397936f6] {\n    margin: 0 20px 0 20px;\n}\n.c-indent-list[data-v-397936f6] {\n    padding: 10px 40px 10px;\n}\n}\n@media screen and (max-width: 896px) {\n.c-indent-list[data-v-397936f6] {\n    padding: 10px 20px 10px;\n}\n}\n", ""]);

// exports
